import * as Yup from 'yup';
import { passwordRegex } from '../../constants';

export const createUserFormYopValidation = () => {
  return Yup.object().shape({
    name: Yup.string().required('required'),
    email: Yup.string().required('required').email('incorrectEmail'),
    password: Yup.string().required('required').min(15, 'min15').matches(passwordRegex, 'passwordPattern'),
    repeatPassword: Yup.string()
      .required('required')
      .oneOf([Yup.ref('password')], 'passwordNotMatch'),
    roleName: Yup.string().required('required'),
  });
};

export const editUserFormYopValidation = () => {
  return Yup.object().shape({
    name: Yup.string().required('required'),
    email: Yup.string().required('required').email('incorrectEmail'),
    roleName: Yup.string().required('required'),
  });
};

export const changePasswordYopValidation = () => {
  return Yup.object().shape({
    password: Yup.string().required('required').min(15, 'min15').matches(passwordRegex, 'passwordPattern'),
    repeatPassword: Yup.string()
      .required('required')
      .oneOf([Yup.ref('password')], 'passwordNotMatch'),
  });
};
